class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.cachedResults = {};
    this.input = qs('input[type="search"]');
    this.predictiveSearchResults = qs('#js-search-modal-predictive');
    this.popularProducts = qs('#js-search-modal-popular');

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 100).bind(this)
    );

    this.init();
  }

  init() {
    const searchTerm = this.input.value.trim();

    if (searchTerm) {
      this.getSearchResults(searchTerm);
      this.open();
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.predictiveSearchResults.innerHTML = this.cachedResults[queryKey];
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&${encodeURIComponent(
        'resources[type]'
      )}=product&resources[options][fields]=title,body,vendor,tag,product_type,variants.title,variants.sku&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.open();
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    if (this.popularProducts) this.popularProducts.style.display = 'none';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    if (this.popularProducts) this.popularProducts.style.display = 'block';
  }
}

customElements.define('predictive-search', PredictiveSearch);
